<template>
  <div class="checkbox-component" v-invalid="validation.is_valid">
    <div class="field">
      <div class="control">
        <label class="checkbox" :for="field.id">
          <input type="checkbox"
                  v-model="formData.fields[field.id].value"
                  @change="formData.inputOnChange(field); removeValidation()"
                  :disabled="field.properties.input_readonly"
                  :id="field.id"
                  :name="field.id">

          <span class="check"></span>
          <span class="control-label">{{ field.label }}</span>
        </label>
        <p class="help is-danger"
           v-if="!validation.is_valid">
          {{ validation.message }}
        </p>
        <p class="help"
           v-if="field.properties.help_text"
           v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'

  export default {
    name: 'checkbox-component',
    props: {
      field: {
        type: FormField
      },
      formData: {
        type: FormData
      }
    },
    computed: {
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      }
    },
    methods: {
      removeValidation () {
        this.validation.is_valid = true
      }
    },
    created () {
      let fieldData = this.formData.fields[this.field.id]
      fieldData.value = fieldData.value || false
    }
  }
</script>

<style lang="sass" scoped>
  li
    list-style-position: inside

</style>
